<template>
  <div>
    <b-tabs card>
      <b-tab
        :active="value.activeToggle"
        v-for="(value, index) in inflationhardertopaceChildren"
        v-bind:key="index"
        :title="value.objectname"
        @click="
          !value.activeToggle ? navigateTab(`${value.objectname}`) : () => {}
        "
      >
      </b-tab>
      <router-view></router-view>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "inflationhardertopace",
  computed: {
    ...mapGetters({
      inflationhardertopace: "inflationhardertopace",
    }),
    inflationhardertopaceChildren() {
      return this.inflationhardertopace.child;
    },
  },
  created() {},
  methods: {
    ...mapActions(["getChartDataById"]),
    getChildChartInfoByName(tabName) {
      let filterChart = this.inflationhardertopaceChildren.filter((item) => {
        if (tabName === item.objectname) {
          // console.log("+++++++++++++++", item);
          item.activeToggle = true;
          return true;
        } else {
          item.activeToggle = false;
        }
      });
      return filterChart[0];
    },
    navigateTab(tabName) {
      let chartinfo = this.getChildChartInfoByName(tabName);
      let chartName = chartinfo.objectname;
      let path = `/Macro_Economic_Indicators/inflationhardertopace/${chartName
        .toLowerCase()
        .replace(/ /g, "")
        .replace(/[-,:&.]/g, "")}`;
      let navigate = true;
      this.getChartDataById({
        id: chartinfo.chartId,
        chartName: chartName,
        path: path,
        navigate: navigate,
      });
    },
    onReloadPageNavigate(tabName) {
      let filterChart = this.inflationhardertopaceChildren.filter((item) => {
        let objectname = item.objectname
          .toLowerCase()
          .replace(/[^a-zA-Z]/g, "");
        // console.log("tabNameeeeeee", tabName, objectname);
        if (tabName === objectname) {
          // console.log("@@@@@@@@@@", item);
          item.activeToggle = true;
          return true;
        } else {
          item.activeToggle = false;
        }
      });
      // console.log("filterChart[0]", filterChart);
      return filterChart[0];
    },
  },
  mounted() {
    if (
      this.$route.path == "/Macro_Economic_Indicators/inflationhardertopace" ||
      this.$route.path == "/Macro_Economic_Indicators/inflationhardertopace/"
    ) {
      let chartinfo = this.inflationhardertopaceChildren[0];
      chartinfo.activeToggle = true;
      let chartName = chartinfo.objectname;
      let path = `/Macro_Economic_Indicators/inflationhardertopace/${chartName
        .toLowerCase()
        .replace(/ /g, "")
        .replace(/[-,:&.]/g, "")}`;
      let navigate = true;
      this.getChartDataById({
        id: chartinfo.chartId,
        chartName: chartName,
        path: path,
        navigate: navigate,
      });
    } else {
      let pathArray = this.$route.path.split("/");
      // console.log("pathArray))))))>>>>>>>>!!!", pathArray[3]);
      // let reloadObj = this.onReloadPageNavigate(pathArray[3]);
      this.onReloadPageNavigate(pathArray[3]);
      // console.log("reloadObj++reloadObj", reloadObj);
    }
  },
};
</script>

<style></style>
